import classnames from 'classnames';
import PropTypes from 'prop-types';

import ShareModalWrapper from '../ShareModalWrapper';

import FavoriteButton from '../BookNowCard/FavoriteButton';
// eslint-disable-next-line import/no-named-as-default

import './ListingSocialButtons.scss';

let SOCIAL_COMPONENTS = [];

const ListingSocialButtons = ({
  listingId,
  deviceOS,
  isRedesign = false,
  className = ''
}) => {
  SOCIAL_COMPONENTS = [
    {
      locoKey: 'listing.social-buttons.share',
      SocialComponent: ShareModalWrapper,
      extraProps: {
        listingId,
        className: classnames('listing-social__share-statistics', {
          'listing-social__share-statistics--redesign': isRedesign
        }),
        deviceOS
      }
    },
    {
      locoKey: 'listing.social-buttons.favorite',
      SocialComponent: FavoriteButton,
      extraProps: {
        iconWithBorder: true
      }
    }
  ];

  return (
    <div className={classnames('listing-social', className)}>
      {SOCIAL_COMPONENTS.map(({ locoKey, SocialComponent, extraProps }) => (
        <SocialComponent
          key={locoKey}
          {...extraProps}
          isRedesign={isRedesign}
        />
      ))}
    </div>
  );
};

ListingSocialButtons.propTypes = {
  listingId: PropTypes.string.isRequired,
  deviceOS: PropTypes.string.isRequired,
  isRedesign: PropTypes.bool,
  className: PropTypes.string
};

export default ListingSocialButtons;
